import { render } from "./ArchivedTasks.vue?vue&type=template&id=73b27d5a&scoped=true"
import script from "./ArchivedTasks.vue?vue&type=script&lang=js"
export * from "./ArchivedTasks.vue?vue&type=script&lang=js"

import "./ArchivedTasks.vue?vue&type=style&index=0&id=73b27d5a&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b27d5a"]])

export default __exports__